import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Login() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { password });
      if (res.data?.success) {
        localStorage.setItem('ego_auth_token', res.data.token);
        toast.success('Welcome');
        navigate('/');
      }
    } catch (err) {
      toast.error('Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm bg-card/60 backdrop-blur-md border border-border rounded-2xl p-8 shadow-xl">
        <div className="flex flex-col items-center mb-6">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
            <Lock size={22} className="text-primary" strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-black font-heading tracking-tight text-primary">EGO Cash Flow</h1>
          <p className="text-sm text-muted-foreground mt-1">Enter password to continue</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            data-testid="login-password-input"
            className="text-center tracking-widest"
          />
          <Button
            type="submit"
            disabled={loading || !password}
            data-testid="login-submit-button"
            className="w-full"
          >
            {loading ? 'Checking...' : 'Login'}
          </Button>
        </form>
      </div>
    </div>
  );
}
